import { AuthorisedRoute } from 'core/router/AuthorisedRoute';
import { useRouteMatch } from 'react-router-dom';
import { CampaignSectionProvider } from 'sections/onsite-campaigns/context/CampaignSectionContext';
import { useOnsiteCampaignInitialState } from 'sections/onsite-campaigns/hooks/useOnsiteCampaignInitialState';
import { CampaignMainArea } from './components/CampaignMainArea';
import { CampaignEditorProvider } from './contexts/CampaignEditorContext';
import { useActiveTab } from './contexts/hooks/useActiveTab';
import { CampaignPerformanceTab } from './tabs/CampaignPerformanceTab/CampaignPerformanceTab';
import { CampaignSettingsTab } from './tabs/CampaignSettingsTab/CampaignSettingsTab';
import { CampaignWorkflowTab } from './tabs/CampaignWorkflowTab/CampaignWorkflowTab';
import { CampaignWorkflowProvider } from './tabs/CampaignWorkflowTab/contexts';
import { YouHaveUnsavedChangesModal } from './components/modals/YouHaveUnsavedChangesModal';
import { CampaignFlowProvider } from './tabs/CampaignWorkflowTab/contexts/CampaignFlowProvider';
import { CampaignWorkflowFormProvider } from './tabs/CampaignWorkflowTab/contexts/CampaignWorkflowFormContext';

const SetInitialState = ({ children }) => {
  const { campaignQuery, templateQuery } = useOnsiteCampaignInitialState();

  const isLoading = campaignQuery.isLoading || templateQuery.isLoading;
  const isError = campaignQuery.isError || templateQuery.isError;

  if (isLoading || isError) {
    return null;
  }

  return <>{children}</>;
};

export const CampaignEditor = () => {
  const { path } = useRouteMatch();
  const activeTab = useActiveTab();

  return (
    <CampaignSectionProvider>
      <CampaignEditorProvider>
        <CampaignWorkflowProvider>
          <CampaignWorkflowFormProvider>
            <CampaignFlowProvider>
              <SetInitialState>
                <CampaignMainArea activeTab={activeTab}>
                  <AuthorisedRoute exact={true} path={`${path}/settings`} component={CampaignSettingsTab} />
                  <AuthorisedRoute exact={true} path={`${path}/workflow`} component={CampaignWorkflowTab} />
                  <AuthorisedRoute exact={true} path={`${path}/performance`} component={CampaignPerformanceTab} />
                </CampaignMainArea>
                <YouHaveUnsavedChangesModal />
              </SetInitialState>
            </CampaignFlowProvider>
          </CampaignWorkflowFormProvider>
        </CampaignWorkflowProvider>
      </CampaignEditorProvider>
    </CampaignSectionProvider>
  );
};
